export default [
    {
        value: 'RH',
        text: 'RH - Recursos humanos'
    },
    {
        value: 'ST',
        text: 'ST - Serviço de terceiros'
    },
    {
        value: 'MC',
        text: 'MC - Material de consumo'
    },
    {
        value: 'MP',
        text: 'MPE - Material permanente e equipamento'
    },
    {
        value: 'VD',
        text: 'VD - Viagens e diárias'
    },
    {
        value: 'OU',
        text: 'OU - Outros'
    },
    {
        value: 'CA',
        text: 'CA - Auditoria contábil e financeira'
    },
    {
        value: 'CT',
        text: 'CT - CITENEL'
    },
    
]